import React, { useCallback } from "react";
import { FiUserCheck } from "react-icons/fi";
import PeopleListPage from "./components/PeopleListPage";
import { useNetworkPermissions, useNetworkService } from "./hooks/useNetworkRecords";
import { CLIENTS_HOME } from "./constants/networkEndpoints";

const CONFIG = {
  noun: "Client",
  plural: "Clients",
  icon: FiUserCheck,
  home: CLIENTS_HOME,
  description: "Clients you have added as contacts. Only clients added by your account appear here.",
  searchLabel: "Search clients",
  emptyHint: "Add your first client to keep their details in one place.",
  storageKey: "network-clients",
  canEditRecords: true,
};

/** /partner/network/clients - the logged-in partner's contacts (same endpoint as the mobile Customers tab) */
const ClientsPage = () => {
  const service = useNetworkService();
  const permissions = useNetworkPermissions();
  const load = useCallback(() => service.listClients(), [service]);
  const remove = useCallback((id) => service.removeClient(id), [service]);

  return <PeopleListPage config={CONFIG} load={load} remove={remove} permissions={permissions} />;
};

export default ClientsPage;
